<template>
    <VJoyWrapper
        data-testid="brief-details-helper"
        no-margin
        class="brief-details-helper joy-mt-4"
        column-gap="1"
        row-gap="1"
        :justify="justify"
        align="center"
    >
        <div class="brief-details-helper__label">
            {{ $t('search.advanced.home-v2.info.mention.label') }}
        </div>
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.job-title')" size="small" variant="inactive" />
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.skills')" size="small" variant="inactive" />
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.experience-level')" size="small" variant="inactive" />
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.daily-rate')" size="small" variant="inactive" />
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.location')" size="small" variant="inactive" />
        <VJoyTag :label="$t('search.advanced.home-v2.info.mention.more')" size="small" variant="inactive" />
    </VJoyWrapper>
</template>

<script lang="ts" setup>
    import {VJoyTag, VJoyWrapper, type TJoyWrapperJustify} from '@maltjoy/core-vue';

    defineProps<{
        justify: TJoyWrapperJustify;
    }>();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .brief-details-helper {
        @include mq.screen_xs() {
            display: none;
        }

        &__label {
            white-space: nowrap;
            margin-right: var(--joy-core-spacing-1);
            font-size: var(--joy-font-size-primary-300);
            color: var(--joy-color-neutral-40);
        }
    }
</style>
